import React, { FormEvent, useContext, useState, useEffect } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import {useReactFlow, applyNodeChanges} from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { processNodeDelete, processNodeFormSubmit, nodeDescription } from "./functions/workflow-parallel-node-configuration";
import { PromptTemplateFormWidget } from "./components/PromptTemplateFormWidget";
import { LLMModelWidget } from "./components/LLMModelWidget";
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import {
    Button
} from '@mui/material';


export const WorkflowParallelNodeConfiguration = () => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog() {
        context.toggleShowParallelModal(false);
    }

    const handleFormSubmit = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode() {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }

    useEffect( () => {
        if (context.activeEditParallelNode !== undefined && context.activeEditParallelNode.data !== undefined) {
            setFormData(context.activeEditParallelNode.data);
        }
    }, [context] );

    const formSchema: RJSFSchema = {
        title: '',
        type: 'object',
        properties: {

        },
    }

    const uiSchema: UiSchema = {

    }

    const widgets: RegistryWidgetsType = {

    }

    return (
        <DefaultFormDialog
            open={ context.showParallelModal }
            title={ "Web Scraper Node" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditParallelNode?.id }</span>
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                id="workflow-scraper-node-configure"
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }) => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    { (context.activeEditParallelNode ) &&
                        <Button
                            variant="contained"
                            color="error"
                            onClick={ deleteNode }
                            type="button">
                            <DeleteIcon />
                            <span>{ "Delete" }</span>
                        </Button>
                    }

                </div>
            </Form>
        </DefaultFormDialog>
    );

}